import React, { useEffect, useRef } from 'react'
import { useState } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import ReactTable from 'react-table';
import { Button, Card, CardBody, CardHeader, Col, Container, DatePicker, Form, FormSelect, ListGroup, ListGroupItem, Row } from 'shards-react';
import { setAlert } from '../../../redux/actions/alert';
import { NavgationPageLocationKey, TimesheetSubscriberStatusList } from '../../../utils/constants';
import { fixedDecimalPlaces, formatNumberAmount, getSubscriberTimesheetStatusClass, getValueInNativeDataType, isSameFormData, moveArrowUpandDown, ptoKeyDownFunc } from '../../../utils/general';
import { setAPIDate, setDateForTable, setInputDate } from '../../../utils/date';
import ConfirmAlert from '../../../components/common/ConfirmAlert';
import UnloadPageConfirm from '../../../components/common/UnloadPageConfirm';
import clientRoutes from "../../../routes/client.routes"
import { delete_client_timesheet_hours, generate_client_timesheet_schedule, get_client_project_list, get_client_timesheet_by_refnum, get_client_timesheet_worker_rates, reset_client_timesheet_details, save_client_timesheet } from '../../../redux/actions/client/clientTimesheet';
import { search_worker_for_client_list } from '../../../redux/actions/client/clientWorkers';
//import Select from 'react-select/base';
import Select from 'react-select'

const AddEditClientTimesheet = ({
    search_worker_for_client_list, clientWorkerList, timesheetDetail, timesheetScheduleList
    , generate_client_timesheet_schedule, delete_client_timesheet_hours, get_client_timesheet_by_refnum
    , save_client_timesheet, get_client_timesheet_worker_rates, timesheetWorkerRates
    , reset_client_timesheet_details, setAlert, get_client_project_list
    , clientProjectListForTimesheet
}) => {

    //For storing state and ids
    const location = useLocation();
    const [refNum, setrefNum] = useState(0);
    const [tableData, setTableData] = useState([]);
    const focusedInput = useRef();
    const [cancelForm, setCancelForm] = useState(false);
    const [currentLocation, setCurrentLocation] = useState('/add-edit-cli-timesheet')
    const allowLocation = ['/cli-timesheet', '/add-edit-cli-timesheet-hours']
    const unblockHandle = useRef();
    const [subscriberRoutesList, setSubscriberRouteList] = useState([]);
    const [redirectAfterSave, setRedirectAfterSave] = useState(false);
    const loginClientCompany = JSON.parse(localStorage.user)?.clientName ?? "";
    const loginClientCompanyId = JSON.parse(localStorage.user)?.userRoles[0].subdomainId ?? 0;
    const [areHoursGenerated, setAreHoursGenerated] = useState(false);

    // -> For autoselect setup
    const [options, setOptions] = useState([]);
    const [value, setValue] = useState();
    const [newVal, setNewVal] = useState('');

    const [confirmAlert, setConfirmAlert] = useState({
        confirmMsg: "",
        visible: false,
        onConfirm: null
    });

    const [pageUnloadConfirm, setPageUnloadConfirm] = useState({
        confirmMsg: "",
        visible: false,
        onConfirm: null,
        onCancell: null
    });

    const history = useHistory();
    const [initialState, setInitialState] = useState({
        timesheetRefNum: '',
        refNum: refNum,
        clientId: loginClientCompanyId,
        workerId: '0',
        payPeriodEndDate: '',
        status: 'Draft',
        note: "",
        totalOvertimeHours: '0',
        totalPtoHours: '0',
        totalRegularHours: '0',
        timesheetHourList: [],
        regularRate: '0',
        overTImeRate: '0',
        projectId: '0',
    })
    const [formData, setFormData] = useState(initialState)
    // const [formDataReplica, setFormDataReplica] = useState(initialState);

    const clientListOptions = <option key={loginClientCompany + loginClientCompanyId} value={loginClientCompanyId}>{loginClientCompany}</option>
    const workerListOptins = clientWorkerList.map(worker => <option key={worker.workerName + worker.userId} value={worker.userId}>{worker.workerName}</option>)

    const onChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    }

    const fetchPathFromObject = (routes) => {
        if (routes !== null) {
            let allPath = routes.filter(x => { if (x.path !== currentLocation && !allowLocation.includes(x.path)) return x.path; }).map(y => y.path);
            setSubscriberRouteList(allPath);
        }
    }

    useEffect(() => {
        if (refNum === 0) {
            if (location.state !== undefined) {
                //Take from state --> Also Add screnario will fall here
                //To DO
                let itemId = location.state?.refNum !== undefined ? location.state?.refNum : 0;
                setrefNum(itemId);
                if (Number(itemId) !== 0) {
                    get_client_timesheet_by_refnum(itemId);
                }

                setFormData({
                    ...formData
                    //, timesheetRefNum: itemId
                    , refNum: itemId
                })
            }
            else if (localStorage.getItem(NavgationPageLocationKey.TimesheetCurrentAddEdit) !== null) {
                //Take from local storage 
                let storageRefNum = localStorage.getItem(NavgationPageLocationKey.TimesheetCurrentAddEdit);
                setrefNum(storageRefNum);
                get_client_timesheet_by_refnum(storageRefNum)
                //Set state for same page
                const newState = { refNum: storageRefNum }
                history.push(location.pathname, newState);
                localStorage.removeItem(NavgationPageLocationKey.TimesheetCurrentAddEdit);
            }
        }

        fetchPathFromObject(clientRoutes);
        search_worker_for_client_list();
        get_client_project_list(loginClientCompanyId);
        return () => {
            localStorage.removeItem("TimesheetData");
            reset_client_timesheet_details();
        }
    }, [])

    useEffect(() => {
        if (Number(formData.workerId) > 0) {
            get_client_timesheet_worker_rates(formData.workerId);
        }
    }, [formData.workerId])

    useEffect(() => {
        if (timesheetWorkerRates !== undefined && timesheetWorkerRates != {}) {
            setFormData({
                ...formData
                , regularRate: timesheetWorkerRates.regularRate
                , overTImeRate: timesheetWorkerRates.overTimeRate
            })
        }
    }, [timesheetWorkerRates])

    const calculateAndFixTableData = (timesheetScheduleList) => {
        if (timesheetScheduleList === undefined)
            return false;

        var revisedList = timesheetScheduleList;
        var totalRegularHours = revisedList.reduce((x, i) => Number(x) + Number(i.regularHours), 0);
        var totalOvertimeHours = revisedList.reduce((x, i) => Number(x) + Number(i.overTimeHours), 0);
        var totalPtoHours = revisedList.reduce((x, i) => Number(x) + Number(i.ptoHours), 0);
        var revisedObject = {
            data: revisedList,
            totalRegularHours: totalRegularHours,
            totalOvertimeHours: totalOvertimeHours,
            totalPtoHours: totalPtoHours
        }
        setTableData({ ...revisedObject });
    }

    useEffect(() => {
        var revisedList = timesheetScheduleList;
        if (revisedList.length === 0) {
            return;
        }

        if (!Object.keys(timesheetScheduleList[0]).includes('refNum')) {
            // New Timesheet and schedule will be not saved and need to add dummy ids(refnum)
            setAreHoursGenerated(true);
            revisedList = (timesheetScheduleList || []).map((x, i) => {
                return { ...x, refNum: i + 1 };
            })
        }
        calculateAndFixTableData(revisedList);
    }, [timesheetScheduleList])

    useEffect(() => {
        if (cancelForm) {
            history.push(currentLocation);
        }
    }, [cancelForm]);

    useEffect(() => {
        if (Object.keys(timesheetDetail).length === 0) {
            setFormData(initialState);
            return;
        }
        //Navigate to hour screen if save is performed from add hours
        if (timesheetDetail.refNum) {
            if (redirectAfterSave) {
                navigateToAddHourScreen(0);
                setRedirectAfterSave(false);
            }
        }

        const fetchData = {
            timesheetRefNum: timesheetDetail.timesheetRefNum,
            refNum: timesheetDetail.refNum,
            clientId: timesheetDetail.clientId,
            workerId: timesheetDetail.workerId,
            payPeriodEndDate: setAPIDate(timesheetDetail.payPeriodEndDate),
            status: timesheetDetail.status,
            note: timesheetDetail.note,
            projectId: timesheetDetail.projectId,
            timesheetHourList: timesheetDetail.timesheetHourList,
        };

        setFormData({
            ...formData,
            timesheetRefNum: timesheetDetail.timesheetRefNum,
            refNum: timesheetDetail.refNum,
            workerId: timesheetDetail.workerId,
            payPeriodEndDate: setAPIDate(timesheetDetail.payPeriodEndDate),
            status: timesheetDetail.status,
            note: timesheetDetail.note,
            projectId: timesheetDetail.projectId,
            timesheetHourList: timesheetDetail.timesheetHourList,
        })

        //Autocomplete stuff
        if (timesheetDetail.projectId > 0)
            setValue({ label: timesheetDetail.projectName, value: timesheetDetail.projectId })

        calculateAndFixTableData(timesheetDetail.timesheetHourList);
        const replica = { ...fetchData }
        localStorage.setItem("TimesheetData", JSON.stringify(replica).trim());
    }, [timesheetDetail, redirectAfterSave]);

    useEffect(() => {
        unblockHandle.current = history.block((targetLocation) => {
            let formDataRep = { ...formData };
            delete formDataRep["totalOvertimeHours"];
            delete formDataRep["totalPtoHours"];
            delete formDataRep["totalRegularHours"];
            delete formDataRep["regularRate"];
            delete formDataRep["overTImeRate"];

            if (subscriberRoutesList.includes(targetLocation.pathname) && localStorage.TimesheetData !== undefined
                && !isSameFormData(formDataRep, JSON.parse(localStorage.TimesheetData))) {
                setCurrentLocation(targetLocation.pathname)
                handlePageUnload()

                if (cancelForm) {
                    return true;
                }
            }
            else {
                return true;
            }
            return false;
        });

        return function () {
            unblockHandle.current && unblockHandle.current()
        }
    })

    const onFocus = (e) => {
        focusedInput.current = e.target.name;
    }

    const onDeleteTimesheetItem = (e, itemId) => {
        e.preventDefault();
        setConfirmAlert({
            ...confirmAlert,
            confirmMsg: 'Are you sure you want to delete these timesheet hours?',
            visible: true,
            onConfirm: async () => {
                const deleted = await delete_client_timesheet_hours(formData.refNum, itemId)
                if (deleted) {
                    get_client_timesheet_by_refnum(formData.refNum);
                }
            }
        })
    }
    const onEditTimesheetItem = (e, refNum) => {
        e.preventDefault();
        navigateToAddHourScreen(refNum);
    }

    const onChangeAllocationAmount = (e, refNum, key, row) => {
        let value = getValueInNativeDataType(e);
        const newData = [...tableData.data];
        newData[row][key] = value;
        setFormData({ ...formData, timesheetHourList: newData });
        calculateAndFixTableData(newData);

        // e.preventDefault();
        // let value = getValueInNativeDataType(e);
        // let tableDataToEdit = tableData.data
        // tableDataToEdit = (tableDataToEdit || []).map((item) => {
        //     if (item.refNum === refNum) {
        //         item[key] = value;
        //     }
        //     return item;
        // })
        // setFormData({ ...formData, timesheetHourList: tableDataToEdit });
        // calculateAndFixTableData(tableDataToEdit);
    };

    const tableColumns = [
        {
            Header: "Description",
            accessor: "description",
            maxWidth: 300,
            minWidth: 250,
            Cell: row => <input
                id={`description-${row.original.refNum}`}
                name={`description-${row.original.refNum}`}
                type="text" labelClasses="my-auto"
                onChange={e => onChangeAllocationAmount(e, row.original.refNum, 'description', row.index)}
                value={row.original.description}
                placeholder="" onFocus={onFocus}
                autoFocus={focusedInput.current === `description-${row.original.refNum}`}
                className="form-control "//align-input-amount-right
                onKeyDown={(e) => { moveArrowUpandDown(e, focusedInput, tableData.data.length ?? 0) }}
            />
        },
        {
            Header: "Day",
            accessor: "day",
            maxWidth: 150,
            minWidth: 100,
        },
        {
            Header: "Date",
            accessor: "date",
            maxWidth: 150,
            minWidth: 100,
            Cell: row => setDateForTable(row.original.date)
        },
        {
            Header: `Regular Rate ${Number(formData.regularRate) > 0 ? fixedDecimalPlaces(formData.regularRate, 2) : "-"}`,
            columns: [{
                Header: "Regular Hours",
                accessor: "regularHours",
                minWidth: 70,
                Cell: row => <input
                    id={`regularHours-${row.original.refNum}`}
                    name={`regularHours-${row.original.refNum}`}
                    dataMaxFracDigits="2" type="text"
                    onChange={e => onChangeAllocationAmount(e, row.original.refNum, 'regularHours', row.index)}

                    value={row.original.regularHours}
                    placeholder="0.00" onFocus={onFocus}
                    labelClasses="my-auto" data-type="monetary"
                    autoFocus={focusedInput.current === `regularHours-${row.original.refNum}`}
                    className="form-control align-input-amount-right"
                    onKeyDown={(e) => { moveArrowUpandDown(e, focusedInput, tableData.data.length ?? 0) }}
                />,
                Footer: <div className="d-flex w-100 justify-content-end text-nowrap custom-margin-tablefooter">
                    <span>{formatNumberAmount(tableData.totalRegularHours, 'en-US', 2, 2)}</span>
                </div>
            }]
        },
        {
            Header: `Overtime Rate ${Number(formData.overTImeRate) > 0 ? fixedDecimalPlaces(formData.overTImeRate, 2) : "-"}`,
            columns: [{
                Header: "Overtime Hours",
                accessor: "overTimeHours",
                minWidth: 95,
                Cell: row => <input
                    id={`overTimeHours-${row.original.refNum}`}
                    name={`overTimeHours-${row.original.refNum}`}
                    dataMaxFracDigits="2" type="text"
                    onChange={e => onChangeAllocationAmount(e, row.original.refNum, 'overTimeHours', row.index)}
                    //value={formatNumberAmount(row.original.overTimeHours, 'en-US', 2, 2)}
                    value={row.original.overTimeHours}
                    placeholder="0.00" onFocus={onFocus}
                    labelClasses="my-auto" data-type="monetary"
                    autoFocus={focusedInput.current === `overTimeHours-${row.original.refNum}`}
                    className="form-control align-input-amount-right"
                    onKeyDown={(e) => { moveArrowUpandDown(e, focusedInput, tableData.data.length ?? 0) }}
                />,
                Footer: <div className="d-flex w-100 justify-content-end text-nowrap custom-margin-tablefooter">
                    <span>{formatNumberAmount(tableData.totalOvertimeHours, 'en-US', 2, 2)}</span>
                </div>
            }]
        },
        {
            Header: "PTO Hours",
            accessor: "ptoHours",
            minWidth: 70,
            Cell: row => <input
                id={`ptoHours-${row.original.refNum}`}
                name={`ptoHours-${row.original.refNum}`}
                dataMaxFracDigits="2" type="text"
                onChange={e => onChangeAllocationAmount(e, row.original.refNum, 'ptoHours', row.index)}
                value={row.original.ptoHours}
                placeholder="0.00" onFocus={onFocus}
                labelClasses="my-auto" data-type="monetary"
                autoFocus={focusedInput.current === `ptoHours-${row.original.refNum}`}
                className="form-control align-input-amount-right"
                onKeyDown={(e) => { ptoKeyDownFunc(e, focusedInput, tableData.data.length ?? 0) }}
            />,
            Footer: <div className="d-flex w-100 justify-content-end text-nowrap custom-margin-tablefooter">
                <span>{formatNumberAmount(tableData.totalPtoHours, 'en-US', 2, 2)}</span>
            </div>
        },
        {
            Header: "Action",
            accessor: "",
            minWidth: 50,
            Cell: row => <span><img src="./icons/edit-square.svg" role="button" height="17.5" width="17.5" className="mr-2"
                onClick={(e) => { onEditTimesheetItem(e, row.original.refNum); }}></img>
                <img role="button" src="./icons/cross-icon.png" height="17.5" width="17.5"
                    onClick={(e) => onDeleteTimesheetItem(e, row.original.refNum)}></img>
            </span>
        }
    ]

    const navigateToAddHourScreen = (refNum) => {
        history.push({
            pathname: `/add-edit-cli-timesheet-hours`,
            state: {
                refNum: refNum, timesheetId: formData.timesheetRefNum
                , timesheetInfo: {
                    client: loginClientCompany
                    , worker: clientWorkerList.filter((x) => x.userId == Number(formData.workerId))[0].workerName
                    , payPeriodEndDate: setInputDate(formData.payPeriodEndDate)
                    , status: formData.status
                }
            }
        });
    }

    const onCancel = () => {
        history.replace(`/cli-timesheet`)
    }

    const saveAndReturn = async (savingobject) => {
        let saved = await save_client_timesheet(savingobject);
        if (saved)
            history.replace(`/cli-timesheet`);
    }

    const OnSubmit = async (e) => {
        e.preventDefault();
        let savingObj = prepareSavingObject();
        if (e.nativeEvent.submitter.name === "saveTimesheet") {
            //Dont change the status and save it as it is
            savingObj.status = savingObj.refNum === 0 ? TimesheetSubscriberStatusList.Created : savingObj.status;
        }
        else if (e.nativeEvent.submitter.name === "reject") {
            savingObj.status = TimesheetSubscriberStatusList.Rejected;
        }
        else if (e.nativeEvent.submitter.name === "approve") {
            savingObj.status = TimesheetSubscriberStatusList.ClientApproved;
        }
        else {
            //Submit flow goes here
            savingObj.status = TimesheetSubscriberStatusList.Submitted;
        }
        saveAndReturn(savingObj);
    }

    const IsTimesheetInfoValid = () => {
        if (formData.payPeriodEndDate !== '' && Number(formData.workerId) > 0 && Number(formData.clientId) > 0) {
            return true;
        }
        else {
            submitForm();
            return false;
        }
    }

    const OnGenerateTimeSheetSchedule = async (e) => {
        e.preventDefault();
        if (formData.payPeriodEndDate !== '' && Number(formData.workerId) > 0 && Number(formData.clientId) > 0) {
            // Call an API to get the information from API
            await generate_client_timesheet_schedule(formData.clientId, formData.workerId, setInputDate(formData.payPeriodEndDate))
        }
        else {
            submitForm();
        }
    }

    const OnAddHours = async (e) => {
        e.preventDefault();
        if (formData.timesheetRefNum === "") {
            if (IsTimesheetInfoValid()) {
                //save timesheet
                let savingObj = prepareSavingObject();
                savingObj.status = TimesheetSubscriberStatusList.Created;
                let saved = await save_client_timesheet(savingObj);
                if (saved)
                    setRedirectAfterSave(true);
            }
            return false;
        }
        navigateToAddHourScreen(0);
    }

    const handlePageUnload = () => {
        setPageUnloadConfirm({
            confirmMsg: 'Data entered is not saved, do you wish to save the information?',
            visible: true,
            onConfirm: () => {
                //Allowing user to stay in same page
            },
            onCancel: () => {
                setCancelForm(!cancelForm)
            }
        })
    }

    const submitForm = () => {
        document.getElementById('btnSave').click();
    }

    const prepareSavingObject = () => {
        let data = { ...formData };
        data.timesheetHourList = (tableData.data || []).map((x) => {
            return {
                ['description']: x.description,
                ['regularHours']: x.regularHours,
                ['overTimeHours']: x.overTimeHours,
                ['ptoHours']: x.ptoHours,
                ['day']: x.day,
                ['date']: x.date,
                ['refNum']: areHoursGenerated ? 0 : x.refNum
            }
        })
        data.payPeriodEndDate = setInputDate(data.payPeriodEndDate);
        data.projectId = value?.value;
        return data;
    }

    useEffect(() => {
        if (clientProjectListForTimesheet.length > 0) {
            let projectList = clientProjectListForTimesheet?.map((item, i) => {
                return { label: item.projectName, value: item.refNum }
                //return <option key={item + i} value={item}>{item}</option>
            })
            setOptions([...projectList]);
            let arrayProject = [...projectList];

            //Nipsy Trick
            if (newVal !== "") {
                let newValId = projectList.filter((x) => { return x.label === newVal })[0]
                setValue(newValId);
                setNewVal("");
            }
        }
    }, [clientProjectListForTimesheet])

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: '38px',
            height: '38px',
            padding: '0 6px',
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: '35px',
            padding: '0 0 0 8px',
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: '0 6px',
            height: '32px',
        }),
        indicatorSeparator: (provided) => ({
            ...provided,
            height: '30px',
            marginTop: '1px',
            marginBottom: '1px',
        }),
    };

    return (
        <>
            <UnloadPageConfirm confirmAlert={pageUnloadConfirm} setConfirmAlert={setPageUnloadConfirm} />
            <ConfirmAlert confirmAlert={confirmAlert} setConfirmAlert={setConfirmAlert} />
            <Container fluid className="main-content-container px-4 pb-4">
                <Form onSubmit={OnSubmit}>
                    <Card small className="details-card w-100 mt-4">
                        <ListGroup flush>
                            <ListGroupItem className="border-card p-3">
                                <Row>
                                    <Col>
                                        <Row form>
                                            <Col lg="2" className="form-group p-2 m-0">
                                                <div className="d-flex flex-row justify-content-between">
                                                    <label>Client <span aria-hidden="true" className="required">*</span></label>
                                                </div>
                                                <div className="d-flex flex-row justify-content-between">
                                                    <FormSelect value={loginClientCompanyId} id="clientId" required
                                                        className='' disabled="true">
                                                        <option value=''>Select Client</option>
                                                        {clientListOptions}
                                                    </FormSelect>
                                                </div>
                                            </Col>

                                            <Col lg="2" className="form-group p-2 m-0">
                                                <div className="d-flex flex-row justify-content-between" >
                                                    <label>Worker <span aria-hidden="true" className="required">*</span></label>
                                                </div>
                                                <div className="d-flex flex-row justify-content-between" >
                                                    <FormSelect value={formData.workerId} id="workerId" required
                                                        name='workerId' onChange={onChange} className=''>
                                                        <option value=''>Select Worker</option>
                                                        {workerListOptins}
                                                    </FormSelect>
                                                </div>
                                            </Col>

                                            <Col lg="2" className="form-group p-2 m-0">
                                                <div className="d-flex flex-row justify-content-between">
                                                    <label>Pay Period End Date <span aria-hidden="true" className="required">*</span></label>
                                                </div>
                                                <div className="d-flex flex-row justify-content-between">
                                                    <DatePicker
                                                        id='payPeriodEndDate' autoComplete='off'
                                                        required
                                                        name='payPeriodEndDate' dateFormat='yyyy-MM-dd'
                                                        value={formData.payPeriodEndDate}
                                                        selected={formData.payPeriodEndDate}
                                                        onChange={(date) => {
                                                            setFormData({ ...formData, payPeriodEndDate: date })
                                                        }}
                                                        placeholderText="YYYY-MM-DD"
                                                    />
                                                </div>
                                            </Col>

                                            <Col lg="2" className="form-group p-2 m-0">
                                                <div className="d-flex flex-row justify-content-between">
                                                    <label>Project </label>
                                                </div>
                                                <div className="d-flex flex-row justify-content-between autocomplete-select">
                                                    <Select
                                                        isClearable
                                                        options={options}
                                                        classNamePrefix="autocomplete"
                                                        onChange={(newValue) => setValue(newValue)}
                                                        value={value}
                                                        styles={customStyles}
                                                    >
                                                    </Select>
                                                </div>
                                            </Col>

                                            <Col lg="4" className="form-group p-2 m-0">
                                                <Row>
                                                    <Col lg="7" className='pt-2 pb-2'>
                                                        <label>Timesheet #</label>
                                                    </Col>
                                                    <Col lg="5" className='pt-2 pb-2 custom-padding-timesheet'>
                                                        <label > {formData.timesheetRefNum !== '' ? formData.timesheetRefNum : 'New'} </label>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col lg="7" className='pt-3 pb-2'>
                                                        <label>Status</label>
                                                    </Col>
                                                    <Col lg="5" className='pt-3 pb-2 custom-padding-timesheet'>
                                                        <label className={getSubscriberTimesheetStatusClass(formData.status)}> {formData.status} </label>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>

                                    </Col>
                                </Row>
                            </ListGroupItem>
                        </ListGroup>
                    </Card>

                    <Card className="tableCard p-0">
                        <CardHeader className="p-0">
                            <Container fluid className="file-manager__filters border-bottom">
                                <Row>
                                    <Col lg="3">
                                        <Button onClick={OnGenerateTimeSheetSchedule}> Generate Timesheet Schedule </Button>
                                    </Col>
                                    <Col lg="3">

                                    </Col>
                                    <Col lg="2">
                                    </Col>
                                    <Col lg="2">
                                    </Col>
                                    <Col lg="2" className="file-manager__filters__rows d-flex justify-content-end">
                                        <Button type="button" id="btnAddHours" onClick={OnAddHours}> Add Hours </Button>
                                    </Col>
                                </Row>
                            </Container>
                        </CardHeader>
                        <CardBody className="p-0">
                            <div className="separated-header">
                                <ReactTable
                                    className="no-border-footer"
                                    columns={tableColumns}
                                    data={tableData.data}
                                    pageSize={tableData.data !== undefined && tableData.data.length > 0 && tableData.data.length > 10 ? tableData.data.length : 10}
                                    // It must be dynamic based on the data enter in grid
                                    showPageSizeOptions={false}
                                    resizable={false}
                                    pagination={false}
                                    showPaginationBottom={false}
                                    noDataText="No results found"
                                />
                            </div>
                            <div className="d-flex flex-row py-4">
                                <Row className={'w-100'}>
                                    <Col lg="3">
                                        <div>
                                            <Button className="mx-2" name="approve" id="btnApprove" type="submit">Approve</Button>
                                            <Button name="reject" type="submit" id="btnReject"> Reject </Button>
                                        </div>
                                    </Col>
                                    <Col lg="5">
                                        <div className='pl-2'>
                                            <input
                                                id="note" name="note" type="text"
                                                onChange={onChange}
                                                placeholder='Note :'
                                                onFocus={onFocus}
                                                value={formData.note}
                                                className="form-control"
                                            />
                                        </div>
                                    </Col>
                                    <Col lg="4">
                                        <div className='d-flex flex-row justify-content-end'>
                                            <Button className="mr-2" name="saveTimesheet" id="btnSave" type="submit">Save Timesheet</Button>
                                            <Button className="mr-2" name="submit" id="btnSubmit" type="submit">Submit</Button>
                                            <Button className="mr-2" id="btnCancel" onClick={onCancel}>Cancel</Button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </CardBody>
                    </Card>
                </Form>
            </Container>
        </>
    )
}

const mapStateToProps = (state) => ({
    clientWorkerList: state.clientWorkers.clientWorkerList,
    timesheetDetail: state.clientTimesheet.timesheetDetail,
    timesheetWorkerRates: state.clientTimesheet.timesheetWorkerRates,
    timesheetScheduleList: state.clientTimesheet.timesheetScheduleList,
    clientProjectListForTimesheet: state.clientTimesheet.clientProjectListForTimesheet,
});
export default connect(mapStateToProps, {
    search_worker_for_client_list,
    setAlert,
    generate_client_timesheet_schedule,
    delete_client_timesheet_hours,
    get_client_timesheet_by_refnum,
    save_client_timesheet,
    get_client_timesheet_worker_rates,
    reset_client_timesheet_details,
    get_client_project_list,
})(AddEditClientTimesheet);